'use client';

import { useEffect, useRef } from 'react';
import { useRouter, usePathname, useSearchParams } from 'next/navigation';

export default function CategoryContentClient() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const queryPage = searchParams.get('page');
  const lastProcessedPage = useRef(null);

  useEffect(() => {
    const pageFromUrl = queryPage ? parseInt(queryPage, 10) : 1;

    if (queryPage && pageFromUrl < 2) {
      router.replace(pathname, { scroll: false });
      return;
    }

    if (pageFromUrl !== lastProcessedPage.current) {
      lastProcessedPage.current = pageFromUrl;
    }
  }, [queryPage, pathname, router]);

  return null;
}
